import React from "react";

import { Stack, Typography, useTheme } from "@mui/material";

interface MenuSpecialNoteProps {
  notes: string;
}

export const MenuSpecialNote = ({ notes }: MenuSpecialNoteProps) => {
  const {
    palette: { oscar },
  } = useTheme();
  return (
    <Stack
      alignItems="center"
      bgcolor={oscar.light.surface.clear}
      border={`1px solid ${oscar.light.borders.gray}`}
      borderRadius={6}
      paddingY={4}
      gap={2}
      mb={3}
      width="100%"
      maxWidth={728}
    >
      <Typography
        variant="headingSLight"
        color={oscar.light.content.content1}
        align="center"
      >
        Special note
      </Typography>
      <Stack
        width="100%"
        alignSelf="center"
        maxWidth={640}
        alignItems="flex-start"
        flexDirection="row"
      >
        <Typography
          variant="bodyRLight"
          fontSize={14}
          color={oscar.light.content.content1}
          textAlign="left"
          sx={{ whiteSpace: "pre-line" }}
        >
          {notes}
        </Typography>
      </Stack>
    </Stack>
  );
};
